export default "__VITE_ASSET__jbf3F_qp__"